import cloneDeep from 'lodash/cloneDeep';
import { HYDRATE } from 'next-redux-wrapper';

import { IFilterSubGroup, ISelectedFilters, selectedFiltersInitial, SortByValues, TFilters } from '~/src/entities/filteredBundles';
import { ITariff } from '~/src/entities/formattedTariff';
import { THydrateAction } from '~/src/store';

export enum EFilteredBundlesTypes {
    SET_GROUP_KEY = 'FILTERED/SET_GROUP_KEY',
    SET_SELECTED = 'FILTERED/SET_SELECTED',
    SET_SORTBY = 'FILTERED/SET_SORTBY',
    SET_ITEMS = 'FILTERED/SET_ITEMS',
    SET_TARRIFS = 'FILTERED/SET_TARRIFS',
    RESET_SELECTED = 'FILTERED/RESET_SELECTED',
}

export interface IFilteredBundles {
    selected: ISelectedFilters[],
    sortBy: SortByValues,
    tariffs: ITariff[] | undefined,
    items: TFilters | undefined,
    sortedItems: IFilterSubGroup | undefined,
    groupKey: 'city' | 'village',
    isVillageTabDisable: boolean,
}

const initialState: IFilteredBundles = {
    selected: cloneDeep(selectedFiltersInitial),
    sortBy: SortByValues.recommended,
    tariffs: undefined,
    items: undefined,
    sortedItems: undefined,
    groupKey: 'city',
    isVillageTabDisable: true,
};

export type TActions = {
    type: EFilteredBundlesTypes,
    payload: Partial<IFilteredBundles> | Record<string, unknown>,
};

const filteredBundlesReducer = (state = initialState, action: TActions | THydrateAction): IFilteredBundles => {
    switch (action.type) {
        case HYDRATE:
            return { ...state };
        case EFilteredBundlesTypes.SET_GROUP_KEY:
        case EFilteredBundlesTypes.SET_SELECTED:
        case EFilteredBundlesTypes.SET_ITEMS:
        case EFilteredBundlesTypes.SET_TARRIFS:
        case EFilteredBundlesTypes.SET_SORTBY:
        case EFilteredBundlesTypes.RESET_SELECTED:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default filteredBundlesReducer;
